import { createSelector } from 'reselect';

const EMPTY_ARRAY = Object.freeze([]);
const EMPTY_OBJECT = Object.freeze({});

const selectPromotion = (state: DefaultRootState) => state.promotion;

export const selectPromotionList = createSelector(
  [selectPromotion],
  (promotion) => promotion?.list || EMPTY_ARRAY
);

export const selectPromotionChangeLoadings = createSelector(
  [selectPromotion],
  (promotion) => promotion?.changeLoadings || EMPTY_OBJECT
);

export const selectPromotionTypes = createSelector(
  [selectPromotion],
  (promotion) => promotion?.promotionTypes || EMPTY_ARRAY
);

export const selectPromotionConditions = createSelector(
  [selectPromotion],
  (promotion) => promotion?.promotionConditions || EMPTY_ARRAY
);

export const selectRecentlyCreatedPromotionCondition = createSelector(
  [selectPromotion],
  (promotion) => promotion?.recentlyCreatedPromotionCondition || EMPTY_OBJECT
);

export const selectPromotionDrawer = createSelector(
  [selectPromotion],
  (promotion) => promotion?.drawer || EMPTY_OBJECT
);

export const selectPromotionDrawerVisible = createSelector(
  [selectPromotionDrawer],
  (drawer) => {
    return drawer?.visible || false;
  }
);

export const selectPromotionDrawerPromotionId = createSelector(
  [selectPromotionDrawer],
  (drawer) => drawer?.promotionId || null
);

export const selectPromotionDrawerPromotion = createSelector(
  [selectPromotionDrawer, selectPromotionList],
  (drawer, list) => {
    if (!drawer) return EMPTY_OBJECT;
    if (drawer.promotionId === 'NEW') return { id: 'NEW' };
    return list.find((l) => l.id === drawer.promotionId) || EMPTY_OBJECT;
  }
);

export const selectPromotionConditionDrawer = createSelector(
  [selectPromotion],
  (promotion) => promotion?.promotionConditionDrawer || EMPTY_OBJECT
);

export const selectPromotionConditionDrawerVisible = createSelector(
  [selectPromotionConditionDrawer],
  (drawer) => drawer?.visible || false
);

export const selectPromotionConditionDrawerCondition = createSelector(
  [selectPromotionConditionDrawer],
  (drawer) => drawer?.promotionCondition || null
);

export const selectPromotionLoading = (actionType: string) => createSelector(
  [(state: DefaultRootState) => state.loading],
  (loading) => loading?.effects?.[`promotion/${actionType}`] || false
);

export const selectPromotionConditionDrawerLoading = createSelector(
  [(state: DefaultRootState) => state.loading],
  (loading) => loading?.effects?.['promotion/createPromotionCondition'] || loading?.effects?.['promotion/editPromotionCondition'] || false
);

export const selectPromotionListLength = createSelector(
  [selectPromotionList],
  (list) => list.length
);
